<template>
  <div>
    <v-row dense>
      <v-col cols="12" sm="6" v-if="value.name !== undefined">
        <v-label for="name">Name</v-label>
        <base-input
          v-model="value.name"
          name="name"
          color="primary"
        />
      </v-col>
      <v-col cols="12" sm="6" v-if="value.firstName !== undefined">
        <v-label for="firstName">First Name</v-label>
        <base-input
          v-model="value.firstName"
          name="firstName"
          color="primary"
        />
      </v-col>
      <v-col cols="12" sm="6" v-if="value.lastName !== undefined">
        <v-label for="lastName"> Last name </v-label>
        <base-input v-model="value.lastName" name="lastName" color="primary" />
      </v-col>
      <v-col cols="12" v-if="value.enrolleeId !== undefined">
        <v-label for="enrolleeId">Enrollee ID</v-label>
        <base-input
          v-model="value.enrolleeId"
          name="enrolleeId"
          color="primary"
        />
        <div class="font-medium dark-gray--text" style="transform: translateY(-14px)">This number may be found on your enrollee ID card or any Explanation of Benefits statement.</div>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" v-if="value.streetAddress !== undefined">
        <v-label for="address"> Street address </v-label>
        <base-input
          v-model="value.streetAddress"
          name="address"
          color="primary"
        />
      </v-col>
    </v-row>

    <v-row dense>
      <v-col cols="6" md="4" v-if="value.city !== undefined">
        <v-label for="city">City</v-label>
        <base-input
          v-model="value.city"
          name="city"
          color="primary"
        ></base-input>
      </v-col>
      <v-col cols="6" md="4" v-if="value.state !== undefined">
        <v-label for="state">State</v-label>
        <base-select
          v-model="value.state"
          :items="states"
          item-text="name"
          item-value="name"
          name="state"
        />
      </v-col>
      <v-col cols="6" md="4" v-if="value.zip !== undefined">
        <v-label for="zip"> Zip code </v-label>
        <base-input
          v-model="value.zip"
          name="zip"
          color="primary"
        />
      </v-col>
    </v-row>

    <v-row dense>
      <v-col cols="12" v-if="value.email !== undefined">
        <v-label for="email"> Email </v-label>
        <base-input v-model="value.email" email name="email" color="primary" />
      </v-col>
      <v-col cols="12" v-if="value.phone !== undefined">
        <v-label for="phone">Phone</v-label>
        <base-input v-model="value.phone" name="phone" color="primary" phone />
      </v-col>
      <v-col cols="12" v-if="value.eveningPhone !== undefined">
        <v-label for="eveningPhone">Evening phone number</v-label>
        <base-input
          v-model="value.eveningPhone"
          name="eveningPhone"
          color="primary"
          phone
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { states } from '../../../../utils/states'
export default {
  name: 'PersonalInformationForm',
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  watch: {
    value () {
      this.$emit('input', this.value)
    }
  },
  data () {
    return {
      states
    }
  }
}
</script>
